import { createBrowserRouter, Outlet } from "react-router-dom";
import { AnalyticsTracker } from "../components/analyticsTracker";
import { AboutPage } from "../pages/about";
import { LandingPage } from "../pages/landingPage";
import { BlogListPage } from "../pages/blog";
import { ArticlePage } from "../pages/blog/ArticlePage";
import { PrivacyPolicyPage } from "../pages/privacy";
import { TermsPage } from "../pages/terms";
import { FaqPage } from "../pages/faqs";
import { CareersPage } from "../pages/careers";
import { JobDetailsPage } from "../pages/careers/JobDetailsPage";
import { PaymentPage } from "../pages/payment";
import { PaymentCallbackPage } from "../pages/payment/callback";
import { PaymentResultPage } from "../pages/payment/result";

const TrackedLayout = () => (
  <>
    <AnalyticsTracker />
    <Outlet />
  </>
);

export const router = createBrowserRouter([
  {
    path: "/",
    element: <TrackedLayout />,
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "faqs",
        element: <FaqPage />,
      },
      {
        path: "careers",
        element: <CareersPage />,
      },
      {
        path: "careers/:jobId",
        element: <JobDetailsPage />,
      },
      {
        path: "terms",
        element: <TermsPage />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "blog",
        element: <BlogListPage />,
      },
      {
        path: "blog/:slug",
        element: <ArticlePage />,
      },
      {
        path: "pay/:token",
        element: <PaymentPage />,
      },
      {
        path: "pay/:token/callback",
        element: <PaymentCallbackPage />,
      },
      {
        path: "pay/:token/success",
        element: <PaymentResultPage type="success" />,
      },
      {
        path: "pay/:token/failure",
        element: <PaymentResultPage type="failure" />,
      },
      {
        path: "*",
        element: <LandingPage />,
      },
    ],
  },
]);
